import React from 'react';
import EArchiveGroupWrapper from './EArchiveGroupWrapper';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';

interface Props {
	groupId: string;
	isSystemGroup: boolean;
	groupType?: string;
	onDelete: () => void;
	onClose: () => void;
}

const EArchiveGroupModal = ({
	groupId,
	isSystemGroup,
	groupType,
	onDelete,
	onClose,
}: Props) => {
	return (
		<Modal opened onClose={onClose} size={Size.FULLSCREEN}>
			<EArchiveGroupWrapper
				groupId={groupId}
				isSystemGroup={isSystemGroup}
				groupType={groupType}
				onDelete={onDelete}
				closeDetail={onClose}
			/>
		</Modal>
	);
};

export default EArchiveGroupModal;
